import { ModuleBase, Stack, Text, Box, ResponsiveImage } from '@/components';
import { SideBySideModuleModel } from './SideBySideModule';
import { fadeIn, fadeInLeft, fadeInRight } from '@/animations';
import classNames from 'classnames';

const HomepageTheFuture = (data: SideBySideModuleModel) => {
  const {
    props: { title, alignment, cards, image },
  } = data;

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: '#f1f0e9' } }}
      noPadding
      className="HomepageTheFuture relative flex-grow overflow-hidden py-8 lg:py-18"
    >
      <Stack
        className={classNames(
          'container flex h-full flex-col justify-between gap-5 lg:items-stretch lg:gap-0',
          alignment === 'Left' ? 'lg:flex-row-reverse' : 'lg:flex-row',
        )}
      >
        <div className="relative w-full sm:px-14 lg:w-1/2 lg:px-0">
          <div className={classNames(alignment === 'Left' ? 'lg:pr-9 lg:pl-18' : 'lg:pr-18 lg:pl-9', 'h-full')}>
            <div className="h-full overflow-hidden">
              {image && image.desktopImage && (
                <ResponsiveImage
                  animation={fadeIn}
                  image={image.desktopImage}
                  widths={{ xs: 380, sm: 500, md: 520, lg: 368, xl: 576, xxl: 900 }}
                  heights={{ xs: 210, sm: 280, md: 290, lg: 491, xl: 576, xxl: 600 }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="flex w-full flex-grow flex-col justify-around lg:w-1/2 lg:justify-center">
          {title && (
            <Text
              animation={alignment === 'Left' ? fadeInRight : fadeInLeft}
              className="text-style-h3 lg:mt-5"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}

          {cards && (
            <div className="mt-6 flex-col gap-5 lg:mt-14">
              {cards.map((card, index) => (
                <Box
                  animation={alignment === 'Left' ? fadeInRight : fadeInLeft}
                  key={index}
                  className={classNames(
                    'flex flex-col gap-1 border-black py-[calc(16*100vh/911)] first:pt-0',
                    index !== 0 &&
                      (alignment === 'Right'
                        ? 'lg:after-extended-line-top border-t lg:border-t-0'
                        : 'border-t border-solid'),
                  )}
                >
                  <p className="text-style-h4">{card.title}</p>
                  {card.text && <div className="text-style-body" dangerouslySetInnerHTML={{ __html: card.text }} />}
                </Box>
              ))}
            </div>
          )}
        </div>
      </Stack>
    </ModuleBase>
  );
};

export default HomepageTheFuture;
